import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=d47c4c32&"
import script from "./HistoryDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports